<template>
	<div v-if="show">
		<!-- 验证码弹出框 -->
		<el-dialog width="648px" :visible.sync="otpShow" :append-to-body="true" @close="otpClose" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="setpage_info_box otp_dialog" style="box-sizing: border-box;padding-bottom: 34px;">
				<div class="otp_dialog_header" style="background-color: rgba(0,0,0,0);">
					<div class="setpage_info_top_title"></div>
					<div class="setpage_info_top_close">
						<img @click="otpClose" class="setpage_info_top_close_icon"
							src="../../../assets/icons/close_icon.png" alt="" />
					</div>
				</div>
				<div class="otp_dialog_content">
					<div class="setpage_tip_item_title">
						<span v-if="tipOperateType==1">
							Confirm your account
						</span>
						<span v-else-if="tipOperateType==2">
							Enter OTP
						</span>
						<span v-else-if="tipOperateType==3">
							<!-- 设置防沉迷时间 -->
							Self exclusion
						</span>
					</div>
					<div class="setpage_tip_item_remark mar_t18">
						<span v-if="tipOperateType==1">
							Enter the email/phone no. you used to register
						</span>
						<span v-else-if="tipOperateType==2">
							A 6-digit code was sent to {{selectPayName}}
						</span>
						<span v-else-if="tipOperateType==3">
						</span>
					</div>

					<div class="setpage_tip_item_input_box">
						<div v-if="tipOperateType==1" class="setpage_wallet_paytype_input">
							<el-input clearable v-model="selectPayName" placeholder="Enter email/phone no." />
						</div>
						<div v-else-if="tipOperateType==2">
							<div class="setpage_verification_container mar_t18">
								<input v-for="(code, index) in verificationCodes" :key="index"
									v-model="verificationCodes[index]" @input="handleInput(index, $event)"
									@keydown="handleKeyDown(index, $event)" maxlength="1"
									class="setpage_verification_input" />
							</div>
						</div>
						<span v-else-if="tipOperateType==3">
							<div class="setpage_wallet_paytype_input">
								<el-select style="width: 100%;" v-model="select" slot="prepend" placeholder="Duration"
									@change="changeSelect">
									<el-option style="height: 50px;" class="flex" v-for="item in selectList" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</div>
						</span>
					</div>
					<div class="tip3_remark">
						<div class="tip3_remark_title">
							Note:
						</div>
						<div class="tip3_remark_content">
							<div>
								LKY7BET’s Self Exclusion option allows players to close their accounts<br>
								unts for a specified time period. During this period, players will not<br>
								be able to bet, play games, or login to their accounts.
							</div>
							<div>
								Self Exclusion placed on accounts will not be lifted by Lky7bet until<br>
								the exclusion period willfully selected by the user naturally elapses.<br>
								
							</div>
						</div>
					</div>


				</div>
				<div @click="continueOtp()" class="def_btn setpage_tip_item_btn">
					{{tipOperateType!=3?'Continue':'Self Exclude'}}
				</div>
			</div>
		</el-dialog>




		<!-- 提示弹窗 -->
		<el-dialog width="370px" :visible.sync="tipShow" :close-on-click-modal="false" :close-on-press-escape="false"
			:show-close="false">
			<div class="setpage_info_box setpage_tip_dia_box">
				<div class="setpage_tip_box">
					<img @click="tipShow=false" class="setpage_tip_item_close_icon"
						src="../../../assets/icons/close_icon.png" alt="" />
					<div class="setpage_tip_item">
						<!-- 密码重置成功 -->
						<img v-if="tipType<3" class="setpage_tip_item_icon" src="../../../assets/icons/tip_icon1.png"
							alt="" />
						<!-- 认证成功 -->
						<img v-else-if="tipType==3" class="setpage_tip_item_icon"
							src="../../../assets/icons/tip_icon5.png" alt="" />
						<!-- 失败提示 -->
						<img v-else-if="tipType==4" class="setpage_tip_item_err_icon"
							src="../../../assets/icons/tip_err_icon.png" alt="" />


						<div class="setpage_tip_item_price color_7A7D7F" v-if="tipType==4">
							oops!
						</div>

						<div class="setpage_tip_item_title2">
							<span v-if="tipType==1">
								<!-- 支付密码重置成功 -->
								PIN Created!
							</span>
							<span v-if="tipType==2">
								<!-- 登录密码重置成功 -->
								Password Created!
							</span>
							<span v-else-if="tipType==3">
								<!-- 认证成功 -->
								Account Verified!
							</span>
							<span v-else-if="tipType==4">
								<!-- 失败提示 -->
								Transaction Failed
							</span>
						</div>

						<div class="setpage_tip_item_remark2">
							<span v-if="tipType==1">
								<!-- 支付密码重置成功 -->
								Congratulations your LKY7BET PIN <br>
								has been successfully created.
							</span>
							<span v-if="tipType==2">
								<!-- 登录密码重置成功 -->
								Your password has been successfully <br>
								updated.
							</span>
							<span v-else-if="tipType==3">
								<!-- 认证成功 -->
								Congratulations your account has <br>
								been verified successfully.
							</span>
							<span v-else-if="tipType==4">
								<!-- 失败提示 -->
								Your Transaction <br>
								was unsuccessful
							</span>
						</div>
					</div>

					<div v-if="tipType<3" @click="clickTipBtn(1)" class="def_btn setpage_tip_btn">
						<!-- 密码设置成功 -->
						Continue
					</div>
					<div v-else-if="tipType==3" @click="clickTipBtn(3)" class="def_btn setpage_tip_btn">
						<!-- 认证通过  -->
						Continue
					</div>
					<div v-else-if="tipType==4" class="setpage_tip_err_btn_box">
						<!-- 充值失败按钮 -->
						<div class="setpage_tip_err_btn " @click="clickTipBtn(2)">
							Cancel
						</div>
						<div @click="clickTipBtn(4)" class="setpage_tip_err_btn setpage_tip_err_btn2">
							Try again
						</div>
					</div>
				</div>
			</div>
		</el-dialog>










	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';


	export default {
		name: 'selfexdialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			...mapState(['user', 'token']), // 映射 user 模块下的 userInfo 状态
		},
		watch: {
			'show': {
				immediate: true, // 立即触发一次
				handler(newType, oldType) {
					if (newType !== oldType) {
						if(newType){
							this.otpShow = true
						}else{
							this.tipShow = false
							this.otpClose()
						}
					}
				}
			}
		},
		data() {
			return {
				setUserInfoShow: false, //设置个人信息


				curMenu: 1, //页面显示状态  按照菜单显示  1用户信息绑定状态  2修改密码  3常见问题
				switchType: true,
				selectPayName: '',
				password: '',
				setMenuList: [{
						id: 1,
						name: 'General Settings',
						icon: 5,
					},
					{
						id: 2,
						name: 'Security',
						icon: 8,
					},
					{
						id: 3,
						name: 'Preferences',
						icon: 9,
					},
				],

				userInfo: {},

				// 绑定手机号邮箱
				bindType: 0, //0输入手机号或邮箱  1输入验证码  
				bindTipShow: false,
				bindVisitor: 1, //1手机号 2邮箱
				bindPar: {
					username: '',
					password: '',
					phone: '',
					code: '',
				},
				areaCodeList: [], //区号列表
				areaCode: { //国家手机号区号
					areaCode: '',
					image: '',
					name: '',
				},


				select: '', //类别筛选
				selectList: [{
					value: 1,
					label: '24 hours',
				}, {
					value: 7,
					label: '7 Days',
				}, {
					value: 30,
					label: '30 Days',
				}, ],
				value: '',
				otpShow: false,
				operateType: 1, // 1设置支付密码  2设置登录密码  
				tipOperateType: 1, //提示弹操作类型 1输入验证账户  2输入账户验证码 3选择防沉迷时间  
				tipShow: false, //提示弹窗是否显示
				tipType: 1, // 1设置支付密码成功 2设置登录密码成功  3 账号认证成功  4失败提示
				verificationCodes: ['', '', '', '', '', ''], // 初始化验证码数组
				verificationCodes2: ['', '', '', ''], // 支付密码4位数

			}
		},
		mounted() {
			if (this.user) {
				this.userInfo = JSON.parse(JSON.stringify(this.user))
			}
			this.getAreaCodeList()
		},
		methods: {
			// 选中筛选枚举
			changeSelect(e) {
				
			},

			getAreaCodeList() {
				this.$api.areaCodeList().then(res => {
					this.areaCodeList = res.data
					if (res.data && res.data.length > 0) {
						this.areaCode = res.data[0]
					}
				})
			},
			// 点击区号列表
			clickAreaItem(item) {
				this.areaCode = item
			},
			loadData() {
				// 根据新的 type 加载数据
				this.curMenu = this.$route.query.type;
			},
			// 验证码
			handleInput(index, event) {
				const value = event.target.value;
				let codesName = 'verificationCodes'
				if (this.operateType == 1 && this.tipOperateType == 3) {
					codesName = 'verificationCodes2'
				}

				this[codesName].splice(index, 1, value); // 更新当前输入框的值
				// 自动跳到下一个输入框
				if (value && index < this[codesName].length - 1) {
					const nextInput = event.target.nextElementSibling;
					if (nextInput) {
						this.$nextTick(() => {
							nextInput.focus();
						});
					}
				}
			},
			handleKeyDown(index, event) {
				// 处理删除操作
				if (event.key === 'Backspace' && !event.target.value && index > 0) {
					const prevInput = event.target.previousElementSibling;
					if (prevInput) {
						this.$nextTick(() => {
							prevInput.focus();
						});
					}
				}
			},
			submitCode() {
				let codesName = 'verificationCodes'
				if (this.operateType == 1 && this.tipOperateType == 3) {
					codesName = 'verificationCodes2'
				}
				const code = this[codesName].join(''); // 拼接验证码
				if (code.length === 6) {
					// 在这里可以添加其他逻辑，例如调用 API 验证验证码
				} else {
					alert('Please enter the complete verification code.');
				}
			},
			// 点击验证验证码
			continueOtp() {
				if (this.tipOperateType == 1) {
					// 输入邮箱或手机号 发送验证码
					if (this.selectPayName == '') {
						return this.$use.msg('Please enter your mobile phone number or email address', 'warning')
					} else {
						// 判断输入的是手机号还是邮箱
						if (this.$use.isValidEmail(this.selectPayName)) {
							// 如果是邮箱
							this.bindPar.phone = this.selectPayName
							this.bindVisitor = 2
							if (this.selectPayName != this.user.email) {
								return this.$use.msg(
									'Please enter the email address bound to the current account',
									'warning')
							}
						} else {
							this.bindPar.phone = this.selectPayName
							this.bindVisitor = 1
							if (this.selectPayName != this.user.phonenumber) {
								return this.$use.msg(
									'Please enter the mobile phone number bound to the current account',
									'warning')
							}
						}
						this.sendCode(2)

					}

					// this.tipOperateType = 2
				} else if (this.tipOperateType == 2) {
					// 校验验证码
					let code = this.verificationCodes.join('')
					this.verifyCode(code, 2)
				} else if (this.tipOperateType == 3) {
					this.setAddicted()
				}
			},
			// 设置防沉迷状态
			setAddicted(){
				if(!this.select){
					return this.$use.msg('Please select the anti-addiction time', 'error')
				}
				
				this.$api.setAddicted({
					time: this.select*24
				}).then(res => {
					this.$store.dispatch('GetInfo')
					this.$use.msg('Self Exclusion Completed!', 'success')
					// 获取防沉迷状态
					this.$store.dispatch('GetSelfType')
					this.otpClose()
				})
			},
			// 设置支付密码
			updatePayPassWord() {
				let password = this.verificationCodes2.join('')
				if (!password || this.verificationCodes2.length != 4) {
					return this.$use.msg('Please enter a 4-digit payment password', 'error')
				}

				this.$api.updatePayPassWord({
					payPassword: password
				}).then(res => {
					this.$track.track('modifyPIN',{userId:this.user.userId});
					this.otpShow = false
					this.tipType = 1
					this.tipShow = true

					this.$store.dispatch('GetInfo')
				})
			},
			// 设置登录密码
			updatePassWord() {
				let password = this.password
				if (!password) {
					return this.$use.msg('Please enter the password.', 'error')
				} else if (!this.$use.isValidPassword(password)) {
					return this.$use.msg(
						'An eight-digit password that contains at least one letter or one number is required', 'error')
				}
				this.$api.updateLoginPassWord({
					password: password
				}).then(res => {
					this.$store.dispatch('GetInfo')
					this.$track.track('modifyPassword',{userId:this.user.userId});
					this.otpShow = false
					this.tipType = 2
					this.tipShow = true
				})
			},


			// 点击提示框中的按钮
			clickTipBtn(type) {
				this.tipShow = false
				if (type == 1) {
					this.otpClose()
					this.otpShow = true
				}
			},
			// 点击页面中的按钮
			clickBtn(type) {
				// type 1认证   2修改支付密码 2修改登录密码  
				//otpShow: false, //输入框弹窗
				//operateType: 1, // 1设置支付密码  2设置登录密码
				//tipOperateType: 1, //提示弹操作类型 1输入验证账户  2输入账户验证码 3设置账户密码
				//tipShow: false, //提示弹窗是否显示
				//tipType: 1, // 1设置支付密码成功 2设置登录密码成功  3 账号认证成功  4失败提示
				if (type == 1) {
					// this.tipType = 3
					// this.tipShow = true
					return this.$use.msg('Not open yet.', 'warning')
				} else if (type == 2) {
					this.operateType = 1
					// 支付密码
					if (this.user.isPayPassword) {
						// 如果有支付密码
						if (this.user.isBindInfo) {
							// 如果绑定了账号或邮箱
							this.tipOperateType = 1
						} else {
							this.$use.msg('Please bind your email or mobile phone number and then make the modification',
								'warning')
							return
						}
					} else {
						this.tipOperateType = 3
					}

					// if(!this.userInfo.email){
					// }

					this.otpShow = true
				} else if (type == 3) {
					// 登录密码isPassword
					if (this.userInfo.isPassword) {
						// 如果有登录密码 &&&
						if (this.user.isBindInfo) {
							// 如果绑定了账号或邮箱
							this.tipOperateType = 1
						} else {
							this.$use.msg('Please bind your email or mobile phone number and then make the modification',
								'warning')
							return
						}
					} else {
						this.tipOperateType = 3
					}
					this.operateType = 2
					this.otpShow = true
				}
			},
			// 关闭输入框弹窗
			otpClose() {
				this.otpShow = false
				this.tipOperateType = 1
				this.selectPayName = ''
				this.password = ''
				
				this.select = ''
				
				this.$emit('close')

				this.closeBindShow()
			},



			// 绑定手机号邮箱
			// 打开绑定
			clickGoBind(type) {
				this.bindVisitor = type
				this.bindTipShow = true
			},
			// 关闭邮箱绑定
			closeBindShow() {
				this.bindTipShow = false
				this.bindPar.phone = ''
				this.bindPar.code = ''
				this.verificationCodes = ['', '', '', '', '', '']
				this.verificationCodes2 = ['', '', '', '', '', '']
				this.bindType = 0
			},
			// 验证码发送
			sendCode(type = 0) {
				let apiName = 'sendSmsCode'
				let par = {
					areaCode: this.areaCode.areaCode || '234',
				}

				if (this.bindVisitor == 1) {
					// 手机号
					apiName = 'sendSmsCode'
					if (!this.formMsg('bindPhone')) {
						return;
					}
					par.phonenumber = this.bindPar.phone
				} else {
					// 邮箱
					apiName = 'sendEmailCode'
					if (!this.formMsg('bindEmail')) {
						return;
					}
					par.email = this.bindPar.phone
				}
				// 手机号  发送手机号验证码
				this.$api[apiName](par).then(res => {
					this.$use.msg('The verification code has been sent', 'success')
					// 发送验证码成功  切换页面状态
					this.bindType = 1
					if (type == 2) {
						this.tipOperateType = 2
					}
				})
			},
			// 校验验证码
			verifyCode(code, type = 0) {
				let par = {
					account: '', //电话号码/EMAIL
					code: code, //验证码
					type: this.bindVisitor == 1 ? 0 : 1, //验证类型0=手机号，1=EMAIL
				}
				if (this.bindVisitor == 1) {
					// 手机号
					par.account = this.selectPayName
				} else {
					// 邮箱
					par.account = this.selectPayName
				}

				this.$api.verifyCode(par).then(res => {
					if(res.data.status){
						if (type == 2) {
							// 防沉迷
							this.tipOperateType = 3
							// 注释掉的2025-7-3
							// this.otpShow = false
							// this.tipType = 3
							// this.tipShow = 1
						}
					}else {
						this.$use.msg('OTP is invalid', 'error')
					}
				})
			},
			// 点击游客确认绑定
			clickVisitorBind() {
				this.bindPar.code = this.verificationCodes.join()

				let par = {
					info: this.bindPar.phone, //电话号码/EMAIL
					code: this.bindPar.code.split(",").join(""), //验证码
					type: 'email', //验证类型email,phone
				}

				if (this.bindVisitor == 1) {
					// 绑定手机
					if (!this.formMsg('bindPhone')) {
						return;
					}
					par.type = 'phone'
				} else if (this.bindVisitor == 2) {
					// 绑定邮箱
					if (!this.formMsg('bindEmail')) {
						return;
					}
					par.type = 'email'
				}

				if (!this.formMsg('bindCode')) {
					return;
				}

				this.$api.bindMobile(par).then(res => {
					this.$use.msg('binding success', 'success')
					this.$store.dispatch('GetInfo')
					setTimeout(() => {
						this.closeBindShow()
					}, 500)
				})
			},
			formMsg(name) {
				let type = true;
				switch (name) {
					case 'bindPhone':
						if (!this.bindPar.phone) {
							type = false
							return this.$use.msg('Please enter your mobile number', 'error')
						}
						break;
					case 'bindEmail':
						if (!this.bindPar.phone) {
							type = false
							return this.$use.msg('Please enter Captcha', 'error')
						} else if (!this.$use.isValidEmail(this.bindPar.phone)) {
							type = false
							return this.$use.msg('Please enter a valid email address', 'error')
						}
						break;
					case 'bindCode':
						if (!this.bindPar.code) {
							type = false
							return this.$use.msg('Please enter the complete Captcha', 'error')
						}
						break;
					default:
						type = true
						return type; // 默认返回 true
				}
				return type
			},



		}
	}
</script>
<style lang="scss">
	.setp_login-form-item {
		.el-input__inner {
			height: 47px !important;
			background: #191D26 !important;
			border: none !important;
			font-size: 16px;
			color: #667182 !important;
		}
	}

	.setp_login-form-item_phone {
		.el-input__inner {
			padding-left: 80px;
		}
	}

	.setpage_wallet_paytype_input {
		.el-input__inner {
			height: 77.86px !important;
			background: #161A22 !important;
			border: none !important;
			font-size: 24px;
			color: #667182 !important;
			border-radius: 11px !important;
		}
	}
</style>
<style scoped lang="scss">
	.tip3_remark {
		text-align: left;
	}

	.tip3_remark_title {
		font-weight: bold;
		font-size: 24px;
		color: #667182;
		margin-top: 35px
	}

	.tip3_remark_content {
		font-size: 18px;
		color: #FFFFFF;
		line-height: 24px;

		div {
			margin-top: 24px
		}
	}
	.otp_dialog {
		height: 700px;
	}
	.otp_dialog_header {
		height: 60px;
		background: #667182;
		.setpage_info_top_close {
			width: 100%;
			display: flex;
			justify-content: right;
		}
	}




	@import url('../../setPage/setPage.scss');
</style>